import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import Select from 'react-select';
import { toast } from "react-toastify";

class   SectionschoolfeecategoryForm extends Component{

    state = {
        id : "",
        sectionId : "",
        transportId : "",
        price : "",
        currency : "",
        status : "",
        error : "",
        
        isModal : false,
        sections : [],
        transports : [],
        chartaccounts : [],
        chartaccountId : [],
        trimesters : [],
        trimesterId : [],
        title : "",
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }
 
    Store = (val = null) =>{
        var data = {
                price : this.state.price > 0 ? this.state.price : null,
                currency : this.state.currency,
                status : this.state.status || 'Actif',
                sectionId : this.state.sectionId ,
                transportId : this.state.transportId ? this.state.transportId : null ,
                schoolfeecategoryId : this.props.formData.id,
                chartaccountsId : this.state.chartaccountId,
                trimestersId : Array.isArray(this.state.trimesterId) ? this.state.trimesterId.filter(val => val?.price > 0) : [],
            }

            let count = 0
            this.state.chartaccountId?.forEach((val => {
                count += parseFloat(val.purcent || 0)
            }))

            let count1 = 0
            this.state.trimesterId?.filter((val) => val.price > 0)?.forEach((val => {
                count1 += parseFloat(val.price || 0)
            }))

            if(parseFloat(count1) != parseFloat(this.state.price))
              return toast(count1 +' total des trimestres est different du prix annuel de '+this.state.price, { theme : "light", style : { backgroundColor : "red", color : "white"}})

            if(parseFloat(count) != parseFloat(100))
              return toast(count +'% est different de 100%! Totalisez 100% svp', { theme : "light", style : { backgroundColor : "red", color : "white"}})

            var request = this.state.id ? axios.put('sectionschoolfeecategories/'+this.state.id, data) : axios.post('sectionschoolfeecategories', data);
            request.then((response) =>{
                this.props.showModal()
                toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
            }).catch((error) => {
                this.setState({
                    error : error.response.data.msg
                })
                toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
            })
    }
    
    async getSections(){
        var sections = await axios.get('sections');
        if(sections.status === 200)
        {
            this.setState({sections : sections.data}) 
        }
    }

    async getChartaccounts(){
        var chartaccounts = await axios.get('chartaccounts');
        if(chartaccounts.status === 200)
        {
            this.setState({ chartaccounts : chartaccounts.data}) 
        }
    }

    async getTrimesters(){
        var trimesters = await axios.get('trimesters');
        if(trimesters.status === 200)
        {
            this.setState({ trimesters : trimesters.data}) 
        }
    }

    async getTransports(){
        var transports = await axios.get('transports');
        if(transports.status === 200)
        {
            this.setState({transports : transports.data}) 
        }
    }

    edit=()=>  {
        this.form()
        this.getSections()
        this.getTransports()
        this.getChartaccounts()
        this.getTrimesters()
    }

    form=()=>{
        const sectionData = this.props.sectionData;
        this.setState({
            id : sectionData ? sectionData.id : "",
            sectionId : sectionData ? (sectionData.sectionId || sectionData.section?.id || "") : "",
            transportId : sectionData ? (sectionData.transportId || sectionData.transport?.id || "") : "",
            price : sectionData ? (sectionData.price || "") : "",
            currency : sectionData ? (sectionData.currency || "") : "",
            status : sectionData ? (sectionData.status || 'Actif') : "",
            chartaccountId : sectionData ? sectionData.chartaccountpurcents?.map((chartaccount) => ({
                chartaccountId : chartaccount.chartaccountId || chartaccount.chartaccount?.id,
                purcent : chartaccount.purcent
            })) || [] : [],
            trimesterId : sectionData ? sectionData.trimesectschools?.map((trime) => ({
                trimesterId : trime.trimesterId || trime.trimester?.id,
                price : trime.price
            })) || [] : [],
            title : sectionData ? "Modifier la section ou axe, " + this.props.formData.category : "Attacher une section ou axe, " + this.props.formData.category,
            error : "",
        })
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }

    render(){
        const selectMenuProps = {
            menuPortalTarget: typeof document !== "undefined" ? document.body : null,
            menuPosition: "fixed",
            classNamePrefix: "student-select",
            styles: { menuPortal: (base) => ({ ...base, zIndex: 1060 }) },
        };
        var optionsections = [] ; 
        this.state.sections.map((section) => {
            optionsections.push({
                value : section.id,
                label : section.short_entitled_section + " " + section.entitled_section
            })
        })

        var optiontransports = [] ; 
        this.state.transports.map((transport) => {
            optiontransports.push({
                value : transport.id,
                label : transport.axe
            })
        })
        
        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="schoolfee-section-dialog"
                contentClassName="ev-form-modal ev-form-modal--compact schoolfee-section-modal"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header className="schoolfee-section-head">
                    <div className="schoolfee-section-head__title">
                        <span><FeatherIcon icon="layers" size={17} /></span>
                        <div>
                            <small>Frais scolaire</small>
                            <Modal.Title>{ this.state.title}</Modal.Title>
                        </div>
                    </div>
                </Modal.Header>
                    <Modal.Body className="row ev-form-body schoolfee-section-form-body">
                    {this.state.error && <div className="col-12"><div className="student-form__alert" role="alert"><FeatherIcon icon="alert-circle" size={15} /><span>{ this.state.error }</span></div></div>}
                    <div className="row p-0 m-0">
                        <div className="col-md-7 row p-0 m-0">
                            <div className="col-12 schoolfee-section-strip">
                                <span><FeatherIcon icon="map" size={14} /></span>
                                <strong>Affectation</strong>
                                <small>Section ou axe</small>
                            </div>
                            <div className="form-group col-md-7">
                                <label className="font-monospace fw-normal">Section</label>
                                <Select
                                    className="form-control form-control-sm p-0"
                                    classNamePrefix="student-select"
                                    placeholder="section"
                                    value = {
                                        optionsections.filter(option => 
                                            option.value == this.state.sectionId)
                                    }
                                    defaultValue={this.state.sectionId}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                sectionId : select.value
                                            });
                                        }
                                    }
                                    options={optionsections}
                                    {...selectMenuProps}
                                />
                            </div>

                            <div className="form-group col-md-5">
                                <label className="font-monospace fw-normal">Axe</label>
                                <Select
                                    className="form-control form-control-sm p-0"
                                    classNamePrefix="student-select"
                                    placeholder="Axe de transport"
                                    value = {
                                        optiontransports.filter(option => 
                                            option.value == this.state.transportId)
                                    }
                                    defaultValue={this.state.transportId}
                                    onChange={
                                        (select) => {
                                        this.setState({
                                                transportId : select.value
                                            });
                                        }
                                    }
                                    options={optiontransports}
                                    {...selectMenuProps}
                                />
                            </div>
                        </div>
                        <div className="col-md-5 row p-0 m-0">
                            <div className="ms-2 col-12 schoolfee-section-strip mt-2">
                                <span><FeatherIcon icon="credit-card" size={14} /></span>
                                <strong>Prix annuel</strong>
                                <small>Montant et repartitions</small>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group has-icon-left">
                                    <label htmlFor="nom-id-icon">Prix annuel</label>
                                    <div className="position-relative mt-1">
                                        <input type="number" className="form-control form-control-sm" placeholder="" onChange={this.handleInput} name="price" value={this.state.price} id="nom-id-icon" />
                                        <div className="form-control-icon">
                                            <FeatherIcon icon="trello" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group col-md-6">
                                <label className="font-monospace fw-normal">Devise</label>
                                <Select
                                    className="form-control form-control-sm p-0"
                                    classNamePrefix="student-select"
                                    placeholder="Devise de paiement"
                                    value = {
                                        [{ value : 'USD', label : 'USD'}, { value : 'CDF', label : 'CDF'} ].filter(option => 
                                            option.value == this.state.currency)
                                    }
                                    defaultValue={this.state.currency}
                                    onChange={
                                        (select) => {
                                        this.setState({
                                                currency : select.value
                                            });
                                        }
                                    }
                                    options={[{ value : 'USD', label : 'USD'}, { value : 'CDF', label : 'CDF'} ]}
                                    {...selectMenuProps}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="col-12 mt-3">
                        <div className="schoolfee-section-subpanel">
                            <div className="schoolfee-section-subpanel__header">
                                <div><span>Caisse</span><h3>Repartition par compte en %</h3></div>
                                <b>100%</b>
                            </div>
                            <div className="schoolfee-section-lines">
                                {
                                    this.state.chartaccounts?.filter( va => this.state.currency == va.currency).map((val, count) => {
                                        return(
                                            <label className="schoolfee-section-line" key={val.id}>
                                                <span><strong>{ val.wording }</strong><small>{ val.amount?.toLocaleString()}{ val.currency }</small></span>
                                                <input type="number" className="form-control form-control-sm"
                                                    value={(this.state.chartaccountId || []).find((item) => String(item.chartaccountId) === String(val.id))?.purcent || ""}
                                                    onChange={(e) => {
                                                        let data = [...this.state.chartaccountId]
                                                        let index = data.findIndex((item) => String(item.chartaccountId) === String(val.id))
                                                        if(e.target.value === ""){
                                                            if(index >= 0) data[index].purcent = ""
                                                            return this.setState({ chartaccountId : data })
                                                        }
                                                        if(parseInt(e.target.value) <= 100 && parseInt(e.target.value) >= 0 ) 
                                                        {
                                                            if(index >= 0){
                                                                data[index].purcent = e.target.value
                                                            }else{
                                                                data.push({
                                                                    chartaccountId : val.id,
                                                                    purcent : e.target.value
                                                                })
                                                            }
                                                            this.setState({
                                                                chartaccountId : data
                                                            })
                                                        }
                                                        else
                                                            toast('Pourcentage non valide', { theme : "light", style : { backgroundColor : "red", color : "white"}})
                                                    }}
                                                />
                                            </label>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mt-3">
                        <div className="schoolfee-section-subpanel">
                            <div className="schoolfee-section-subpanel__header">
                                <div><span>Montant</span><h3>Ventilation annuelle</h3></div>
                                <b>{this.state.price || 0} {this.state.currency}</b>
                            </div>
                            <div className="schoolfee-section-lines schoolfee-section-lines--quarters">
                                {
                                    this.state.trimesters?.filter(v => this.state.currency).sort((a, b) => a.id - b.id).map((val, count) => {
                                        return(
                                            <label className="schoolfee-section-line" key={val.id}>
                                                <span><strong>{ val.short_trimester }</strong></span>
                                                <input type="number" className="form-control form-control-sm"
                                                    value={(this.state.trimesterId || []).find((item) => String(item.trimesterId) === String(val.id))?.price || ""}
                                                    onChange={(e) => {
                                                        let data = [...this.state.trimesterId]
                                                        let index = data.findIndex((item) => String(item.trimesterId) === String(val.id))
                                                        if(e.target.value === ""){
                                                            if(index >= 0) data[index].price = ""
                                                            return this.setState({ trimesterId : data })
                                                        }
                                                        if(parseInt(e.target.value) <= parseFloat(this.state.price || 0) && parseInt(e.target.value) > 0 ) 
                                                        {
                                                            if(index >= 0){
                                                                data[index].price = e.target.value
                                                            }else{
                                                                data.push({
                                                                    trimesterId : val.id,
                                                                    price : e.target.value
                                                                })
                                                            }
                                                            this.setState({
                                                                trimesterId : data
                                                            })
                                                        }
                                                        else
                                                            toast('Le montant par trimestre est non valide', { theme : "light", style : { backgroundColor : "red", color : "white"}})
                                                    }}
                                                />
                                            </label>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="col-6 mt-2 mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Statut</label>
                            <div className="position-relative mt-1">
                                <select className="form-control form-control-sm" name="status" onChange={this.handleInput}>
                                    <option></option>
                                    <option value={"Actif"}>Actif</option>
                                    <option value={"Inactif"}>Inactif</option>
                                </select>
                            </div>
                         </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <span className="ev-form-footer-note"><FeatherIcon icon="info" size={13} /> Les trimestres doivent totaliser le prix annuel.</span>
                    <button onClick={this.props.showModal} className="btn btn-light ev-form-button"><FeatherIcon icon="corner-down-left" /> Fermer</button>
                    <button onClick={() => this.Store()} className="btn btn-primary ev-form-button"><FeatherIcon icon="check-square" /> Sauvegarder</button>
                </Modal.Footer>
            </Modal>
            </div>
        )
    }
}
export default SectionschoolfeecategoryForm;

